@if (selectedWidgets.length !== 1) {
  <div class="sidebar-content">
    <form [formGroup]="form">
      <div class="row global-settings-spacer" formGroupName="settings">
        <div class="col-sm-12">
          <p><strong>{{ 'DASHBOARD.GLOBAL_SETTINGS.PRIMARY_PERIOD' | translate }}</strong></p>
        </div>
        <div class="col-sm-12">
          <rma-period formControlName="primaryPeriod" [(type)]="periodType" [showType]="true" [whiteLabel]="true"></rma-period>
        </div>
        <div class="col-sm-12">
          <p><strong>{{'DASHBOARD.GLOBAL_SETTINGS.SECONDARY_PERIOD' | translate }}</strong></p>
        </div>
        <div class="col-sm-12">
          <rma-period formControlName="secondaryPeriod" [(type)]="periodType" [showType]="false" [whiteLabel]="true"></rma-period>
        </div>
        <div class="col-sm-12">
          <button class="btn btn-primary float-right"
            (click)="updateDashboardSettings()"
            [disabled]="buttonDisabled">
            {{'BTN.APPLY' | translate}}
          </button>
        </div>
      </div>
      @if ((widgetOptions$ | async)?.length >= 1) {
        <div class="row">
          <div class="col-sm-12">
            <p><strong>{{ 'DASHBOARD.GLOBAL_SETTINGS.ADD_WIDGET' | translate }}</strong></p>
            <rma-select formControlName="widgetOption"
              [placeholder]="'FORM.CHOOSE'"
              [options]="filteredOptions$ | async"
              (valueChanged)="addWidget($event)">
            </rma-select>
          </div>
        </div>
      }
    </form>
  </div>
}
